/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Groupssystemleft2Inputs */

const en_groupssystemleft2 = /** @type {(inputs: Groupssystemleft2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} left the group`)
};

const de_groupssystemleft2 = /** @type {(inputs: Groupssystemleft2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} hat die Gruppe verlassen`)
};

/**
* | output |
* | --- |
* | "{name} left the group" |
*
* @param {Groupssystemleft2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const groupssystemleft2 = /** @type {((inputs: Groupssystemleft2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Groupssystemleft2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_groupssystemleft2(inputs)
	return de_groupssystemleft2(inputs)
});
export { groupssystemleft2 as "groupsSystemLeft" }